import { stylesheet } from 'typestyle';
import {
  flexRoot,
  layerParent,
  horizontal,
  centerCenter,
  newLayer
} from 'csstips';
import {
  regularGrayText,
  linkBlueText,
  regularYellowText
} from '@styles/general';

export default stylesheet({
  title: {
    color: regularGrayText,
    fontSize: 14,
    fontWeight: 600,
    margin: '27px 0 6px 0'
  },

  listContainer: {
    ...flexRoot
  },

  listItem: {
    width: '30%',
    cursor: 'pointer',

    $nest: {
      '&:not(:first-child)': {
        marginLeft: '5%'
      }
    }
  },

  imageSquareContainer: {
    ...layerParent,

    width: '100%',
    paddingTop: '100%',
    marginBottom: 9
  },

  imageBox: {
    ...horizontal,
    ...centerCenter,
    ...newLayer,

    width: '100%',
    border: '1px solid #e4e3e3'
  },

  image: {
    maxHeight: '95%',
    maxWidth: '95%'
  },

  description: {
    color: linkBlueText,
    fontSize: 14,
    lineHeight: '18px',

    $nest: {
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },

  price: {
    color: regularYellowText
  }
});
